import React from 'react';
import PropTypes from 'prop-types';

import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import ScoreArc, {ARC_LENGTH, SIZE} from "./components/ScoreArc";

import {getScoreLevel} from "views/marketplace/retailer/product/utils/ScoreColorCalculator";

import {black500, green500, greyishBlue500, orange500, red500} from "assets/jss/main";

ScoreGraph.propTypes = {
    score: PropTypes.number,
    title: PropTypes.node,
    tooltip: PropTypes.string
};

const TEXT_BLOCK_OVERLAP = 40;

const SCORE_COLORS = {
    0: red500,
    1: orange500,
    2: green500
};

function ScoreGraph({score, title, tooltip}) {
    const isScoreEmpty = score == null;
    const clampedScore = isScoreEmpty ? 0 : Math.min(100, Math.max(0, score));

    const colorLevel = getScoreLevel(clampedScore) ?? 0;
    const scoreColor = isScoreEmpty ? greyishBlue500 : SCORE_COLORS[colorLevel];

    const filledLength = isScoreEmpty ? 0 : (clampedScore / 100) * ARC_LENGTH;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: `${SIZE + 16}px`
        }}>
            <ScoreArc
                color={scoreColor}
                filledLength={filledLength}
                isEmpty={isScoreEmpty}
            />

            <div style={{
                marginTop: `-${TEXT_BLOCK_OVERLAP}px`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%'
            }}>
                <div style={{
                    fontSize: '32px',
                    fontWeight: 700,
                    color: black500
                }}>
                    {isScoreEmpty ? 'NA' : `${clampedScore}%`}
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                    <span style={{
                        fontSize: '14px',
                        color: black500,
                        whiteSpace: 'nowrap'
                    }}>
                        0
                    </span>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <span style={{
                            fontSize: '14px',
                            color: black500
                        }}>
                            {title}
                        </span>

                        {tooltip && (
                            <InfoTooltipIcon titleId={tooltip} />
                        )}
                    </div>

                    <span style={{
                        fontSize: '14px',
                        color: black500,
                        whiteSpace: 'nowrap'
                    }}>
                        100%
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ScoreGraph;
